module.exports = __webpack_public_path__ + "static/media/Seam_4510.60c5fc3a.jpg";